import React from "react";
import styles from "./skeleton.module.scss";

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  count?: number;
  className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = "100%",
  height = 20,
  borderRadius = "4px",
  count = 1,
  className,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`${styles.skeleton} ${className || ""}`}
          style={{ width, height, borderRadius }}
        />
      ))}
    </>
  );
};

export const SkeletonCard: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`${styles.card} ${className || ""}`}>
    <Skeleton height={160} borderRadius="8px 8px 0 0" />
    <div className={styles.cardBody}>
      <Skeleton height={24} width="70%" />
      <Skeleton height={16} count={2} />
      <Skeleton height={32} width="40%" borderRadius="16px" />
    </div>
  </div>
);

export default Skeleton;
